import {
  amountInWords,
  formatCheckDate,
  formatCheckNumericAmount,
} from "./amountInWords";
import {
  DEFAULT_PRIZE_LINE_COLUMNS,
  SAMPLE_PRIZE_LINES,
  SAMPLE_PRIZE_TOTAL,
  normalizePrizeLineColumns,
  prizeLinesFieldText,
} from "./checkPrizeLines";

export const CHECK_FIELD_TYPES = [
  { value: "payeeName", label: "Payee name" },
  { value: "amount", label: "Prize amount" },
  { value: "amountInWords", label: "Amount in words" },
  { value: "checkDate", label: "Check date" },
  { value: "tournamentName", label: "Tournament name" },
  { value: "tournamentDate", label: "Tournament date" },
  { value: "place", label: "Place" },
  { value: "eventName", label: "Event name" },
  { value: "teamName", label: "Team name" },
  { value: "prizeDescription", label: "Prize description" },
  { value: "memo", label: "Memo" },
  { value: "prizeLines", label: "Prize lines" },
  { value: "customText", label: "Custom text" },
];

export const CHECK_FIELD_TYPE_LABELS = CHECK_FIELD_TYPES.reduce((map, type) => {
  map[type.value] = type.label;
  return map;
}, {});

export const SAMPLE_CHECK_VALUES = {
  payeeName: "Jane Bowler",
  amount: formatCheckNumericAmount(SAMPLE_PRIZE_TOTAL),
  amountInWords: amountInWords(SAMPLE_PRIZE_TOTAL),
  checkDate: formatCheckDate("2026-08-23"),
  tournamentName: "Labor Day Open",
  tournamentDate: formatCheckDate("2026-08-23"),
  place: "1st",
  eventName: "Singles",
  teamName: "",
  prizeDescription: "1st Place — Singles",
  memo: "1st Place — Singles",
  customText: "Prize winnings",
  prizes: SAMPLE_PRIZE_LINES,
};

export const MAX_CUSTOM_TEXT_LENGTH = 120;
export const MAX_CHECK_FIELDS = 40;

export const createCheckField = (fieldType, existingFields = []) => {
  const stacked = existingFields.length * 0.32;
  const isPrizeLines = fieldType === "prizeLines";
  return {
    id:
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `field-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    fieldType,
    xInches: isPrizeLines ? 0.5 : 0.75,
    yInches: isPrizeLines ? 4 : 0.4 + stacked,
    widthInches:
      fieldType === "amountInWords" ? 6 : isPrizeLines ? 7.5 : 3.5,
    heightInches: fieldType === "amountInWords" ? 0.4 : isPrizeLines ? 2.2 : 0.28,
    fontFamily: "helvetica",
    fontSizePt: isPrizeLines ? 10 : 12,
    fontBold: fieldType === "amount" || fieldType === "payeeName",
    fontItalic: false,
    textAlign: fieldType === "amount" ? "right" : "left",
    overflow:
      fieldType === "amountInWords" || isPrizeLines ? "wrap" : "truncate",
    customText: fieldType === "customText" ? "" : null,
    prizeLineColumns: isPrizeLines
      ? { ...DEFAULT_PRIZE_LINE_COLUMNS }
      : null,
  };
};

export const fieldDisplayValue = (field, values = SAMPLE_CHECK_VALUES) => {
  if (!field) return "";
  if (field.fieldType === "customText") {
    return field.customText || "";
  }
  if (field.fieldType === "prizeLines") {
    return prizeLinesFieldText(field, values);
  }
  return values[field.fieldType] || "";
};

export { normalizePrizeLineColumns };
